var chunkToChildrenMap = {
	"8295": [
		34063,
		73273,
		96089,
		44810,
		77332,
		23740,
		36102,
		73590,
		65567,
		54664,
		55240,
		73959,
		70526,
		45332,
		311,
		89407,
		9556,
		48809,
		31060,
		35979,
		90204,
		57095,
		20162,
		1092,
		97058,
		56094,
		51105,
		41897,
		89796,
		52061,
		17978,
		2742,
		26838,
		55593,
		52685,
		99612,
		58926,
		52011,
		71177,
		22739,
		91648,
		20033,
		18882,
		9773,
		51484,
		47120,
		83357,
		83871,
		72351,
		24580,
		82796,
		17501,
		80127,
		63619,
		50784,
		1570,
		14893,
		58295,
		37770,
		86863,
		59000,
		10989
	],
	"16397": [
		70447
	],
	"27665": [
		70447
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));